import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    root: {
      width: '100%',

      '&:focus-within': {
        '& $label': {
          borderColor: theme.colors.borderFocus,
        },
      },
    },

    disabled: {
      '& $label': {
        borderBottomColor: theme.colors.borderDisabled,
        cursor: 'default',

        '&:hover': {
          background: 'transparent',
          borderBottomColor: theme.colors.borderDisabled,
        },
      },

      '& $labelText': {
        color: theme.colors.textDisabled,
      },

      '& $icon': {
        color: theme.colors.iconDisabled,
      },
    },

    opened: {
      '& $label': {
        borderBottomColor: 'transparent',
      },

      '& $content': {
        pointerEvents: 'all',
      },
    },

    label: {
      boxSizing: 'border-box',
      cursor: 'pointer',
      height: 44,
      padding: [theme.spacing.sp03, theme.spacing.sp04],
      display: 'flex',
      justifyContent: 'space-between',
      border: [1, 'solid', 'transparent'],
      borderBottomColor: theme.colors.borderSubtle,
      outline: 'none',
      background: 'transparent',
      transition: 'all 0.2s ease-out',
      width: '100%',
      userSelect: 'none',

      '&:hover': {
        background: theme.colors.backgroundSubtleHover,
        borderBottomColor: 'transparent',
      },
    },

    labelText: {
      fontWeight: 400,
      color: theme.colors.textPrimary,
    },

    icon: {
      color: theme.colors.iconPrimary,
    },

    content: {
      boxSizing: 'border-box',
      pointerEvents: 'none',
    },

    contentText: {
      fontWeight: 400,
      padding: [theme.spacing.sp02, theme.spacing.sp04],
      color: theme.colors.textPrimary,
    },
  },
  {
    name: 'AccordionOption',
  },
);
